export default class Tooltip extends Component {
  handleMouseIn() {
    if (!this.props.isNotTabbable) {
      this.$tooltip.tooltip('show')
    }
  }

  handleMouseOut() {
    this.$tooltip.tooltip('hide')
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.title != this.props.title || nextProps.isDisabled !== this.props.isDisabled
  }

  componentDidMount() {
    this.activateTooltip()
  }

  componentDidUpdate() {
    this.activateTooltip()
  }

  activateTooltip() {
    const  { placement, container, isNotTabbable } = this.props
    this.$tooltip = $(this.tooltipcontainer)

    if (!isNotTabbable) {
      this.$tooltip.tooltip({container: `${container}`, placement: `${placement}`})
    } else {
      this.$tooltip.tooltip('destroy')
    }
  }

  render() {
    const  { title, isDisabled, isNotTabbable, label, style = {} } = this.props

    return (
      <div ref={node => this.tooltipcontainer = node}
        data-toggle="tooltip"
        data-original-title={title}
        onFocus={this.handleMouseIn.bind(this)}
        onBlur={this.handleMouseOut.bind(this)}
        aria-label={label}
        role="button"
        aria-disabled={isDisabled}
        tabIndex={isNotTabbable ? -1 : 0}
        style={isNotTabbable ? { opacity: '.5', cursor: 'default', ...style } : { ...style }}
      >
        {this.props.children}
      </div>
    )
  }
}
